import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import AdminPage from "./pages/AdminPage";
import AvisoLegalPage from "./pages/AvisoLegalPage";
import PoliticaPrivacidadPage from "./pages/PoliticaPrivacidadPage";
import PoliticaCookiesPage from "./pages/PoliticaCookiesPage";
import CookieBanner from "./components/CookieBanner";

function App() {
  return (
    <div className="App font-sans">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/aviso-legal" element={<AvisoLegalPage />} />
          <Route path="/politica-de-privacidad" element={<PoliticaPrivacidadPage />} />
          <Route path="/politica-de-cookies" element={<PoliticaCookiesPage />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#0B0E13",
            border: "1px solid rgba(199, 170, 120, 0.4)",
            color: "#F2EFEA",
            fontWeight: 500,
          },
        }}
      />
    </div>
  );
}

export default App;
